<template>
  <v-list-item class="ui-list-item" @click="handleClick" :href="href" :to="to" :base-color="color">
    <template v-slot:prepend v-if="icon">
      <ui-icon :name="icon" :color="color" />
      <slot name="prepend"></slot>
    </template>

    <v-list-item-title v-if="title">{{ title }}</v-list-item-title>

    <v-list-item-subtitle v-if="subtitle">{{ subtitle }}</v-list-item-subtitle>

    <template v-slot:append>
      <div v-if="arrow" class="ui-arrow-append">
        <ui-icon name="chevron-right" :size="16" :color="color" />
      </div>
      <slot v-else></slot>
    </template>
  </v-list-item>
</template>

<script>
export default {
  name: "UiListItem",
  props: {
    // Naam van het icoon dat je wilt weergeven (optie voor ui-icon)
    icon: {
      type: String,
      default: "",
    },
    // Kleur voor het icoon
    color: {
      type: String,
      default: "",
    },
    // Titel voor de lijstitem
    title: {
      type: String,
      default: "",
    },
    // Subtitel voor de lijstitem
    subtitle: {
      type: String,
      default: "",
    },
    // URL voor de link
    href: {
      type: String,
      default: "",
    },
    arrow: {
      type: Boolean,
      default: false,
    },
    // Vue Router link (voor single page apps)
    to: {
      type: [String, Object],
      default: "",
    },
  },
  methods: {
    // Methode voor het afhandelen van de klikactie
    handleClick() {
      if (this.to) {
        // Als 'to' prop is opgegeven, wordt er naar de route genavigeerd
        this.$router.push(this.to);
      } else if (this.href) {
        // Als 'href' is opgegeven, wordt de gebruiker doorgestuurd naar de URL
        window.location.href = this.href;
      }
    },
  },
};
</script>
